<template>
<!-- eslint-disable max-len -->
<span>
  <transition enter-active-class="animated slideInDown" leave-active-class="animated fadeOut">
    <div class="report-container" id="report-container">
      <div :class="`report ${pdf ? 'pdf' : ''}`" ref="report" id="report">
        <div :class="`report-header ${pdf ? 'pdf' : ''}`">
          <!-- logo -->
          <img v-if="logo" :src="resolveAssetPath(logo, 'ui/customer')" :class="`logo ${pdf ? 'pdf' : ''}`" ref="logo">
          <!-- title -->
          <h1 class="report-title no-wrap">{{activeEnvironment.reportTitle || game.reportTitle || 'Report'}}</h1>
        </div>

        <!-- name/date -->
        <div :style="{
          display: 'flex',
          'flex-flow': 'row nowrap',
          'justify-content': 'space-between',
          padding: '4px 50px',
          'font-size': '1.6em',
        }">
          <div class="no-wrap">
            {{username}}
          </div>
          <div class="no-wrap">
            {{date}}
          </div>
        </div>

        <!-- divider -->
        <div
          class="primarybox"
          :style="{
            height: '3px',
          }"
        >
        </div>

        <!-- score -->
        <div
          :style="{
            padding: '8px 50px',
            'font-size': '1.6em',
          }"
        >
          Tus puntos: <span style="font-size: 1.65em;">{{ score }}</span>
        </div>

        <!-- divider -->
        <div
          class="primarybox"
          :style="{
            height: '3px',
          }"
        >
        </div>

        <!-- static content -->
        <div :style="{
          padding: '8px 50px',
          'font-size': '1.25em',
        }">
          <div style="font-weight: bold;">¿Cuál es el objetivo de azúcar en la sangre?</div>
          <br>
          <div>El objetivo de azúcar en la sangre es el rango en el que uno debe de tratar de mantenerse. Estos son los objetivos típicos:</div>
          <br>
          <ul>
            <li>Rango antes de comer: entre 80 a 130 mg/dL</li>
            <li>Dos horas después del inicio de una comida: menos de 180 mg/dL</li>
            <li>El nivel de azúcar en la sangre menos de 70 mg/dL es considerado bajo</li>
          </ul>
          <div>El Nivel bajo de azúcar en la sangre:</div>
          <ul>
            <li>El nivel de azúcar en la sangre menos de 70 mg/dL es considerado bajo. Si cree que tiene un nivel bajo de azúcar en la sangre, Cheque sus niveles.</li>
            <br>
            <li>Si no puede checar, continúe y trátelo consumiendo azúcares de acción rápida (como azúcar, refrescos regulares o jugos de frutas).</li>
            <br>
            <li>Y luego coma azúcar de acción prolongada (como galletas saladas y queso, o un sándwich con carne).</li>
            <br>
            <li>Un nivel bajo de azúcar en la sangre no tratado puede ser peligroso, así que es importante saber qué hacer y tratarlo inmediatamente.</li>
          </ul>
          <div>
            <a target="_blank" href="https://www.cdc.gov/diabetes/es/about/acerca-de-los-niveles-bajos-de-azucar-en-la-sangre-hipoglucemia.html">El nivel bajo de azúcar en la sangre</a> (también llamado hipoglucemia) tiene muchas causas, incluyendo: saltar una comida, tomar demasiada insulina, tomar otros medicamentos para la diabetes, hacer más ejercicio de lo normal y beber alcohol.
          </div>
          <div>Los síntomas comunes de <span style="font-weight: bold;">niveles bajos de azúcar en la sangre</span> incluyen:</div>
          <ul>
            <li>Temblores</li>
            <li>Sudor</li>
            <li>Nerviosismo o ansiedad</li>
            <li>Irritabilidad o confusión</li>
            <li>Mareos</li>
            <li>Hambre</li>
          </ul>
          <div>
            Si cree que puede tener niveles bajos de azúcar en la sangre, revíselo incluso si no tiene síntomas. <span style="font-weight: bold;">Un nivel bajo de azúcar en la sangre puede ser peligroso</span> y debe tratarse lo antes posible.
          </div>
          <br>
          <div>
            <a target="_blank" href="https://www.cdc.gov/diabetes/es/treatment/manejo-de-los-niveles-de-azucar-en-la-sangre.html">https://www.cdc.gov/diabetes/es/treatment/manejo-de-los-niveles-de-azucar-en-la-sangre.html</a>
          </div>
          <br>
          <!-- divider -->
          <div
            class="primarybox"
            :style="{
              height: '3px',
            }"
          >
          </div>
          <br>
          <div>Los síntomas comunes de niveles altos de azúcar en la sangre incluyen:</div>
          <ul>
            <li>Sentirse muy cansado</li>
            <li>Estar sediento</li>
            <li>Tener la visión borrosa</li>
            <li>Tener que orinar (hacer pis) más seguido</li>
          </ul>
          <div>
            Muchas cosas pueden causar niveles altos de azúcar en la sangre (hiperglucemia), como estar enfermo, estresado, comer más de lo planeado y no administrarse suficiente insulina. Con el tiempo, un nivel alto de azúcar en la sangre puede provocar problemas de salud graves al largo plazo.
          </div>
          <br>
          <div>
            <a target="_blank" href="https://assets.redmeru.com/master/documents/hpgs_documents/flu-sick-days.html">Si se enferma</a>, puede ser difícil controlar su nivel de azúcar en la sangre. Es posible que no pueda comer ni beber tanto como de costumbre, lo que puede afectar los niveles de azúcar en la sangre. Si está enfermo y su nivel de azúcar en la sangre es de 240 mg/dL o más, use un kit de prueba de cetonas de venta libre para checar la presencia de cetonas en la orina y llame a su médico si sus cetonas están altas.
            <span style="font-weight: bold;">Los niveles altos de cetonas pueden ser un signo de cetoacidosis diabética, que es una emergencia médica y debe tratarse de inmediato.</span>
          </div>
          <br>
          <div>
            <a target="_blank" href="https://www.cdc.gov/diabetes/es/treatment/manejo-de-los-niveles-de-azucar-en-la-sangre.html">https://www.cdc.gov/diabetes/es/treatment/manejo-de-los-niveles-de-azucar-en-la-sangre.html</a>
          </div>
        </div>

        <!-- divider -->
        <div
          class="primarybox"
          :style="{
            height: '3px',
          }"
        >
        </div>

        <!-- footer message (e.g. displaying ©) -->
        <div :style="{
          padding: '2px 25px',
          width: '100%',
          'border-top': '1px solid white',
          'background-color': 'black',
          color: 'white',
        }">
          {{activeEnvironment.reportFooter}}
        </div>
      </div>
    </div>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="showDownloading" class="download-message">Downloading!</div>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <button v-if="showNextButton"
      class="btn download-button"
      @click.prevent="onClickDownload"
    >Download</button>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <bottom-bar v-if="showNextButton" :next="showNarratorNotification ? onComplete : undefined" :tabindex="3" ref="bottomBar" :noBar="true">
      <span slot="button">
        <span v-html="(narrative && narrative.nextButtonText) ? narrative.nextButtonText : ((game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next')"></span>
      </span>
    </bottom-bar>
  </transition>
</span>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import JsPDF from 'jspdf';
import domtoimage from 'dom-to-image-more';

import Narrator from '../ui/Narrator';
import NarratorNotification from '../ui/NarratorNotification';
import BottomBar from '../ui/BottomBar';

export default {
  // $emit 'input' on complete
  components: {
    Narrator,
    NarratorNotification,
    BottomBar,
  },
  data() {
    return {
      showNextButton: false,
      showDownloading: false,
      showNarrator: false,
      showNarratorNotification: false,
      pdf: false,
      score: 0,
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'activeClass',
      'characters',
      'tooltip',
      'narrative',
      'lastNarrative',
      'nextNarrative',
      'narrativeNavbarText',
      'narrativeText',
      'group',
      'me',
      'metrics',
      'game',
      'dateActiveGameCompleted',
      'challenge'
    ]),
    username() {
      const {
        firstName = '',
        lastName = '',
        email = ''
      } = this.me || {};
      return firstName || lastName ? `${firstName} ${lastName}` : email;
    },
    date() {
      return (this.game.carryOverMetricsFromActive && this.dateActiveGameCompleted != null)
        ? new Date(this.dateActiveGameCompleted).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        : ((this.challenge && this.challenge.completed)
          ? new Date(this.challenge.completed).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
          : ((this.group && this.group.updated)
            ? new Date(this.group.updated).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
            : new Date(Date.now()).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })));
    },
    reportFileName() {
      return (this.activeClass != null && this.activeClass.studentReportFileName != null)
        ? this.activeClass.studentReportFileName
        : (this.activeEnvironment.reportTitle || this.game.reportTitle || 'Report');
    },
    logo() {
      return this.activeEnvironment.reportLogo || this.activeEnvironment.creditsLogo || this.activeEnvironment.titleLogo;
    },
  },
  methods: {
    ...mapActions([
      'getMyGroup',
      'stopSounds'
    ]),
    async show() {
      this.showNarrator = true;
      await Vue.nextTick();
      this.stopSounds();
      await new Promise(resolve => setTimeout(resolve, 1250));
      this.showNarratorNotification = true;
      await new Promise(resolve => setTimeout(resolve, 1250));
      await Vue.nextTick();
    },
    async reset() {
      await Vue.nextTick();
      await this.show();
    },
    navigate() {
      this.$refs.bottomBar.navigate();
    },
    async onComplete() {
      if (this.tooltip && this.tooltip.preventStateProgressionWhileOpen) {
        window.dispatchEvent(new Event('click'));
        return;
      }
      this.$emit('input');
    },
    async loadPageData() {
      try {
        const { _id: groupId } = this.group;
        await this.getMyGroup({ groupId });
      } catch (err) {
        if (await this.$router.handleGameError(err)) return;
        this.$router.showGameErrorCritical();
      }
    },
    setStats() {
      console.log(this.group);
      // TODO: the following order-dependent coupling is not ideal, but it currently seems
      //       to be the best way to do this given the way the data is currently organized.
      //       An ID-based coupling or a name-based coupling seems similarly dicey,
      //       and they'd just be costlier to compute.

      if (this.group && this.group.metrics && this.group.metrics.length && this.group.metrics[0]) {
        this.score = this.group.metrics[0].value;
      }
    },
    onBeforePrint(mql) {
      if (mql instanceof Event) {
        this.pdf = true;
        setTimeout(() => {
          this.pdf = false;
        }, 250);
      } else if (mql.matches) {
        this.pdf = true;
        setTimeout(() => {
          this.pdf = false;
        }, 250);
      }
    },
    iOS() {
      const platform = navigator.platform || navigator.userAgentData.platform;
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    },
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    async onClickDownload() {
      if (this.showDownloading) return;
      this.showDownloading = true;
      // PDF download works in all browsers except pre-chromium Edge
      // (fails at domtoimage.toPng, and no replacement seems viable, see above)
      // fix for Edge (for now): make the page printable, and open the print dialog automatically
      // (in response to domtoimage.toPng or any other part of the autodownload throwing any error)
      // The user can print to PDF or actually print. Bonus is you can print in other browsers too.
      // Edge requires the user to manually set the Scale in the print dialog to 50% for it to fit.
      // Note that this is generally no longer a problem with the new chromium-based Edge.
      this.pdf = true;
      try {
        await Vue.nextTick();
        let dataUrl = await domtoimage.toPng(this.$refs.report, { cacheBust: true });
        // redundant calls required to work on Safari... (https://github.com/tsayen/dom-to-image/issues/343)
        const brokenBecauseSafari = this.iOS() || this.isSafari();
        if (brokenBecauseSafari) {
          dataUrl = await domtoimage.toPng(this.$refs.report);
          dataUrl = await domtoimage.toPng(this.$refs.report);
        }
        const doc = new JsPDF('p', 'pt', 'a4');
        doc.addImage(dataUrl, 'PNG', 28, 50, 540, 747);

        // TODO: if no autodownload, no soft-lock (explained below), so soft-lock fix commented out
        doc.save(`${this.reportFileName}.pdf`);
        // Before we download the PDF, we have to consider the possibility that the
        // user's settings are set to view the PDF in the browser first when downloading a PDF
        // (instead of actually downloading it). This can be true in many modern browsers.
        // This is a problem because if it opens in the same page, it destroys the Vue app state.
        // This ends up soft-locking the player such that they can't get past the report page.
        // This problem came to my attention when a Firefox update changed the PDF download behavior
        // to default to viewing it in browser (on the same page) when you initiate a download.
        // To fix this while minimally impacting anyone whose browser actually just downloads stuff
        // when a download is initiated, instead first open a new tab, then artificially initiate
        // the download with a bogus DOM hyperlink element that targets the bloburl output by JsPDF,
        // which either downloads the file or loads the blob viewer. If it doesn't load the
        // blob viewer, we autoclose the tab, leaving you back on the report page. If it does load
        // the blob viewer, the user is left in the blob viewer, where they can either:
        // - close it, returning to the original report tab without downloading, where they can
        //   hit print or refresh to save off the report another way, or continue on with the game.
        // - download/print it (which presents a system dialog, and does carry over the expected
        //   default name) (and then close it to return back to the game).
        // eslint-disable-next-line max-len
        // const win = window.open(`${window.location.origin}/downloadplayerreport/${encodeURIComponent(this.reportFileName)}/${encodeURIComponent(doc.output('bloburl', { filename: `${this.reportFileName}.pdf` }))}`, '_blank');
        // if (win == null) {
        //   doc.save(`${this.reportFileName}.pdf`);
        // }

        this.pdf = false;
        this.showDownloading = false;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to download report PDF!', error);
        try {
          this.pdf = true;
          this.selectedTab = 0;
          await Vue.nextTick();
          window.print();
          this.pdf = false;
          this.showDownloading = false;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('Failed to open print dialog!', e);
          this.pdf = false;
          this.showDownloading = false;
          this.selectedTab = 0;
        }
      }
    },
  },
  watch: {
    async narrative(newValue) {
      if (newValue) await this.reset();
    },
  },
  async mounted() {
    this.setStats();
    await Vue.nextTick();
    this.stopSounds();

    // polyfill for safari but works for others as well
    const mediaQueryList = (window.matchMedia != null) ? window.matchMedia('print') : null;
    if (mediaQueryList != null && mediaQueryList.addListener != null) {
      mediaQueryList.removeListener(this.onBeforePrint);
      mediaQueryList.addListener(this.onBeforePrint);
    } else {
      // what you'd normally use, if you weren't needing to support Safari:
      window.removeEventListener('beforeprint', this.onBeforePrint);
      window.addEventListener('beforeprint', this.onBeforePrint);
    }

    await this.show();

    await new Promise((resolve, reject) => {
      if (this.$refs.logo.complete) { // wait for logo to load
        resolve();
      } else {
        this.$refs.logo.addEventListener('load', resolve);
        this.$refs.logo.addEventListener('error', reject);
      }
    });

    // uncomment to enable autodownload (but re-add soft-lock fix above if you do)
    // await this.onClickDownload();

    this.showNextButton = true;
  },
};
</script>

<style lang="scss" scoped>
@media print {
  body, body * {
    visibility: hidden !important;
    overflow: visible !important;
  }
  #report-container, #report-container * {
    visibility: visible !important;
    overflow: visible !important;
  }
  #report-container {
    left: 8.75% !important;
    top: 0 !important;
    width: 82.5% !important;
    overflow: visible !important;
    z-index: 10 !important;

    // this makes background graphics show up without needing to check the box
    color-adjust: exact !important;
    print-color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
  }
}

.no-wrap {
  white-space: nowrap;
}

.download-button {
  position: absolute;
  bottom: 210px;
  right: 0;
  width: 350px;
  font-size: 28px;
  line-height: 55px;
  margin-right: 45px;
  z-index: 100 !important;
  transition: opacity 0.5s ease-in-out;
}

hr {
  border-top: 1px solid #e9ecef;
}
.report {
  background-color: white;
  color: black;
}
.report.pdf {
  border: solid;
  border-width: 3.5px;
  border-color: var(--primaryColor);
}
.report-container {
  position: absolute;
  width: 1150px;
  height: 850px;
  top: 20px;
  left: 30px;
  z-index: 1;
  overflow: auto;
}

.report-header {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 50px;
  background-color: black;
  color: lightgrey;
}
.logo {
  object-fit: contain;
  height: 90%;
  max-width: 40%;
  z-index: 10;
}
.report-title {
  font-size: 1.96em;
  white-space: pre-wrap;
  text-align: right;
  margin: auto 0;
  max-width: 60%;
  max-height: 100%;
  line-height: 100%;
}

.primarybox {
  background-color: var(--primaryColor);
  color: white;

  color-adjust: exact;
  -webkit-print-color-adjust: exact;
}

// https://stackoverflow.com/a/31633969/10747078
br {
  display: block;
  content: '';
  margin-top: 0.95em;
}

.slideInDown {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1); // out expo
}
.fadeOutUp {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); // in cubic
}
.narrator-notification {
  bottom: 205px;
}

.download-message {
  position: absolute;
  top: 50%;
  left: 25%;
  z-index: 1000;
  border-radius: 15px;
  border: 3px solid black;
  background-color: var(--primaryColor);
  color: white;
  font-size: 30pt;
  padding: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/game/narrative/NarrativeReportHPGS.vue